// extracted by mini-css-extract-plugin
module.exports = {"ImageEditor":"ImageEditor_ImageEditor__2HJot","ImageViewerWrap":"ImageEditor_ImageViewerWrap__21Uiz","Header":"ImageEditor_Header__3jjHc","Btn":"ImageEditor_Btn__3KZex"};